/**
 * テナント選択。候補は viewer.memberships から引く。
 *
 * 切り替えは認可のやり直しになる。tenant_id は引数ではなくトークンのクレームから
 * 決まるので、別のテナントを見るにはそのテナント向けのトークンを取り直すしかない。
 * 認可リクエストへどの名前で載せるかは API 側の PR で確定するため、
 * パラメータ名は設定（VITE_ADMIN_OAUTH_TENANT_PARAM）で差し替えられるようにしてある。
 */

import { Navigate, useNavigate } from "react-router";
import {
  Button,
  Card,
  PageHeader,
  Tag,
  useSession,
} from "visumo-data-agent-web-shared";

import { HelpIcon } from "../help/HelpIcon";
import { useViewer } from "../ViewerContext";

const ROLE_LABEL: Record<string, string> = {
  TENANT_ADMIN: "管理者",
  TENANT_EDITOR: "編集者",
  TENANT_VIEWER: "閲覧者",
  CS_DELEGATE: "代行",
};

export function TenantSelectPage() {
  const viewer = useViewer();
  const session = useSession();
  const navigate = useNavigate();

  // 代行先は委任されたテナントで固定する。担当者本人の所属一覧へ誘導しない。
  if (viewer.delegation != null || viewer.role === "CS_DELEGATE") {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="vd-page">
      <PageHeader
        title="どの会社の画面を開きますか"
        description="いまログインしているアカウントが入れる会社の一覧です。"
        titleExtra={<HelpIcon slug="account/tenant-select" />}
      />
      <div className="vd-stack">
        {viewer.memberships.map((membership) => {
          const current = membership.tenant.id === viewer.tenant.id;
          return (
            <Card
              key={membership.tenant.id}
              title={
                <>
                  {membership.tenant.label}
                  {current ? <Tag tone="ok">いま開いています</Tag> : null}
                  <Tag>{ROLE_LABEL[membership.role] ?? membership.role}</Tag>
                </>
              }
              extra={
                current ? (
                  <Button
                    variant="primary"
                    onClick={() => navigate("/", { replace: true })}
                  >
                    この会社で続ける
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      void session.login({
                        tenantId: membership.tenant.id,
                        returnTo: "/",
                      });
                    }}
                  >
                    この会社に切り替える
                  </Button>
                )
              }
            >
              <p className="vd-stat-note" style={{ margin: 0 }}>
                会社を切り替えるときは、その会社のトークンを取り直すためにログインを
                もう一度通ります。
              </p>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
